import { render } from "./ChooseValidationTarget.vue?vue&type=template&id=330c6fc0&scoped=true"
import script from "./ChooseValidationTarget.vue?vue&type=script&lang=js"
export * from "./ChooseValidationTarget.vue?vue&type=script&lang=js"

import "./ChooseValidationTarget.vue?vue&type=style&index=0&id=330c6fc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330c6fc0"]])

export default __exports__